import { useState } from 'react';
import { Stack, Button, Divider, Box } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useController } from 'react-hook-form-v7';
import { COLORS } from '../../../../utils/Application_Constants';
import ButtonWithDropdownMenu from '../../ButtonWithDropdownMenu';
import CheckboxList from './CheckboxList';

const styles = () => ({
    scrollableContent: {
        overflowY: 'scroll',
        maxHeight: '300px',
        paddingLeft: 8,
        paddingRight: 8,
    },
    menuPaperRoot: {
        paddingLeft: 8,
        paddingRight: 8,
    },
});

const CheckboxMenu = ({
    classes,
    control,
    name,
    label,
    defaultValue,
    options,
    render,
    onApply,
    onReset,
}) => {
    const { field } = useController({ control, name, defaultValue });
    const [isOpen, setIsOpen] = useState(false);

    // Submit the form and close the menu
    const handleApply = () => {
        setIsOpen(false);
        onApply();
    };

    // Close the menu without applying any changes and reset UI
    const handleClose = () => {
        setIsOpen(false);
        onReset();
    };

    // Reset the filter to it's default values
    const handleResetFilter = () => field.onChange(defaultValue);

    return (
        <ButtonWithDropdownMenu
            label={`${label} (${field.value?.length ? field.value.length : 'All'})`}
            open={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={handleClose}
            buttonProps={{
                sx: {
                    border: `1px solid ${COLORS.LT_JOURNEY}`,
                    borderRadius: '20px',
                    backgroundColor: COLORS.LT_JOURNEY10,
                    color: COLORS.LT_JOURNEY,
                },
            }}
            menuProps={{ classes: { paper: classes.menuPaperRoot } }}
            dropdownContent={
                <>
                    <Box className={classes.scrollableContent}>
                        <CheckboxList field={field} options={options} render={render} />
                    </Box>
                    <Divider />
                    <Stack direction="row" justifyContent="flex-end" pt={2} gap={2}>
                        <Button variant="outlined" onClick={handleResetFilter}>
                            Reset
                        </Button>
                        <Button variant="contained" onClick={handleApply}>
                            Apply
                        </Button>
                    </Stack>
                </>
            }
        />
    );
};

export default withStyles(styles)(CheckboxMenu);
